import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
  selector: 'lib-filter-box',
  templateUrl: './filter-box.component.html',
  styleUrls: ['./filter-box.component.css']
})
export class FilterBoxComponent implements OnInit {
  @Output() searchEmitter = new EventEmitter<string>();
  @Input() control: AbstractControl = {} as FormControl;
  @Input() idName: string = 'id';
  @Input() label: string = '';
  @Input() disabled: boolean = false;
  @Input() prefixDropdownReq?: string;
  public externalTrigger: boolean = false;
  @Input() autofocus?: boolean;

  constructor() { }
  actionSearch() {
    this.externalTrigger = true;
  }
  ngOnInit(): void {
  }
}
